export default __webpack_public_path__ + "static/media/Star-empty.f9ca2f0f.svg";